<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Comprehensive Summary</h4>
                <p class="text-muted m-t-0">Summarized information of Purchase order, Sale order, Invoice</p>
            </div>
            <div class="col-4">
                <div class="text-right">
                    <h4 class="font-medium m-b-0">{{biz_name}}</h4>
                    <span>Name</span>
                </div>
            </div>
        </div>

        <!-- Cards -->
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <span class="text-cyan display-6"><i class="fa fa-cart-arrow-down"></i></span>
                            </div>
                            <div class="ml-auto">
                                <h2>{{summary.po.count}}</h2>
                                <h6 class="text-cyan">Purchases</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <span class="text-ink display-6"><i class="fas fa-dolly"></i></span>
                            </div>
                            <div class="ml-auto">
                                <h2>{{summary.commodity.count}}</h2>
                                <h6 class="text-ink">Commodities</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <span class="text-success display-6"><i class="fa fa-credit-card"></i></span>
                            </div>
                            <div class="ml-auto">
                                <h2>{{summary.so.count}}</h2>
                                <h6 class="text-success">Sales</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <span class="text-orange display-6"><i class="fa fa-dollar-sign"></i></span>
                            </div>
                            <div class="ml-auto">
                                <h2>{{summary.inv.count}}</h2>
                                <h6 class="text-orange">Invoices</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{biz_name}}</h4>
                        <h5 class="card-subtitle">Overview of purchases, sales and invoices</h5>

                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <router-link class="nav-link" :class="{'active' : this.$route.name === 'purchasesummary'}" data-toggle="tab" role="tab" :to="{name: 'purchasesummary'}">
                                    <span class="hidden-xs-down">Purchases</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :class="{'active' : this.$route.name === 'salessummary'}" data-toggle="tab" role="tab" :to="{name: 'salessummary'}">
                                    <span class="hidden-xs-down">Sales</span>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :class="{'active' : this.$route.name === 'invoicessummary'}" data-toggle="tab" role="tab" :to="{name: 'invoicessummary'}">
                                    <span class="hidden-xs-down">Invoices</span>
                                </router-link>
                            </li>
                        </ul>
                        <!-- Tab panes -->
                        <div class="tab-content tabcontent-border">
                            <div class="tab-pane active" id="code" role="tabpanel">
                                <router-view :props="memberid"></router-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Vue from "vue";

    export default {
        name: "Summary",
        props: ["memberid"],
        computed: {
            ...mapGetters(["currentOrg"])
        },
        data() {
            return {
                events: new Vue(),
                summary: {
                    po: {
                        count: 0
                    },
                    so: {
                        count: 0
                    },
                    inv: {
                        count: 0
                    },
                    commodity: {
                        count: 0
                    }
                },
                biz_name: ""
            };
        },
        mounted() {
            this.getGrowerSummary();
        },
        methods: {
            async getGrowerSummary() {
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/summaryCount");

                this.summary = result.data;
                this.biz_name  = result.data.name.biz_name;
            }
        }
    }
</script>

<style scoped>

</style>